import { defaultInputConfig } from './defaultInputConfig'

export const handleFieldTypeChange = (
  value: any,
  currentElementState: any,
  setCurrentElementState: React.Dispatch<any>,
  element: any
) => {
  const previousFieldType = currentElementState[element] || 'INPUT_TEXT'
  const newFieldType = value.value

  setCurrentElementState((prevState: any) => {
    let newState = { ...prevState }
    const defaultConfig = defaultInputConfig.default

    // Check if the new field type exists in defaultInputConfig (except 'default')
    if (newFieldType !== 'default' && defaultInputConfig[newFieldType as keyof typeof defaultInputConfig]) {
      // When changing TO a special field type, insert new keys right after form_field_type
      const typeConfig = defaultInputConfig[newFieldType as keyof typeof defaultInputConfig]

      // Find keys that exist in the special field type but not in default
      const newKeys = Object.keys(typeConfig).filter(
        (key) => !defaultConfig.hasOwnProperty(key as keyof typeof defaultConfig)
      )

      // Reconstruct the object with proper order
      const reorderedState: any = {}

      // Add all keys up to and including form_field_type
      Object.keys(newState).forEach((key) => {
        reorderedState[key] = newState[key]
        if (key === element) {
          // Set the new field type
          reorderedState[element] = newFieldType
          // Add new keys right after form_field_type
          newKeys.forEach((newKey) => {
            if (!newState.hasOwnProperty(newKey)) {
              reorderedState[newKey] = typeConfig[newKey as keyof typeof typeConfig]
            }
          })
        }
      })

      newState = reorderedState
    } else if (
      previousFieldType !== 'default' &&
      defaultInputConfig[previousFieldType as keyof typeof defaultInputConfig] &&
      (newFieldType === 'default' || !defaultInputConfig[newFieldType as keyof typeof defaultInputConfig])
    ) {
      // When changing FROM a special field type to a normal type, remove keys that don't exist in default
      Object.keys(newState).forEach((key) => {
        if (!defaultConfig.hasOwnProperty(key as keyof typeof defaultConfig)) {
          delete newState[key]
        }
      })
    }

    // Set the new field type
    newState[element] = newFieldType

    return newState
  })
}
